import React from 'react';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

import {
    DEFAULT_LAT,
    DEFAULT_LNG,
    DEFAULT_MAP_PREVIEW_ZOOM,
} from 'common/constants';

const getMarkers = (positions) =>
    positions.reduce(
        (acc, { lat, lng }) => acc + `&markers=color:red%7C${lat},${lng}`,
        '',
    );

const StaticMap = ({
    center,
    height = '250',
    maptype = 'roadmap',
    otherMarkers = [],
    scale = 2,
    width = '1000',
    zoom = DEFAULT_MAP_PREVIEW_ZOOM,
}) => {
    if (isEmpty(center)) return null;

    const centerPosition = `${get(center, 'lat', DEFAULT_LAT)},${get(center, 'lng', DEFAULT_LNG)}`;
    const key = import.meta.env.VITE_GOOGLE_MAPS_KEY;
    const markers = getMarkers([center, ...otherMarkers]);
    const size = `${width}x${height}`;
    const url = `https://maps.googleapis.com/maps/api/staticmap`;

    const src = `${url}?center=${centerPosition}&key=${key}&maptype=${maptype}${markers}&scale=${scale}&size=${size}&zoom=${zoom}`;
    const style = {
        borderRadius: '8px',
        display: 'block',
        height: `${height}px`,
        objectFit: 'cover',
        width: '100%',
    };

    return <img src={src} style={style} />;
};

StaticMap.propTypes = {
    center: PropTypes.object,
    height: PropTypes.string,
    maptype: PropTypes.string,
    otherMarkers: PropTypes.array,
    scale: PropTypes.number,
    width: PropTypes.string,
    zoom: PropTypes.number,
};

export default StaticMap;
